package com.iregained.site.pages

import androidx.compose.runtime.Composable
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page

@Page("/clinicians")
@Composable
fun CliniciansPage() {
    // Restructured for modern Med-Tech narrative flow using existing copy
    val pageSections: List<CmsSection> = listOf(
        CmsSection.CliniciansHeroSection(),             // 1. Hook
        CmsSection.CliniciansImpactBarSection(),        // 2. Core Pillars (From the old circle graphic)
        CmsSection.ClinicalApplicationsSection(),
        CmsSection.CliniciansWorkflowSection(),         // 3. Clinical Application & Approach
        CmsSection.CliniciansImplementationSection(),   // 4. Clinician Implementation
        CmsSection.CliniciansTargetedMessagingSection(),      // 5. Post-Purchase Support
        CmsSection.CliniciansEvidenceSection(),     // 6. Objection Handling
        CmsSection.CliniciansProcurementSection(),     // 6. Objection Handling
        CmsSection.CliniciansFaqSection(),         // 7. Conversion
        CmsSection.CliniciansCtaSection()         // 7. Conversion
    )

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}